__turbopack_context__.v({
  "login__background_avatar": "login-module__q3r_BG__login__background_avatar",
  "login__background_mobile": "login-module__q3r_BG__login__background_mobile",
  "login__container": "login-module__q3r_BG__login__container",
  "login__footer": "login-module__q3r_BG__login__footer",
  "login__link": "login-module__q3r_BG__login__link",
  "login__logo": "login-module__q3r_BG__login__logo",
  "login__subtitle": "login-module__q3r_BG__login__subtitle",
  "login__subtitle_highlight": "login-module__q3r_BG__login__subtitle_highlight",
  "login__title": "login-module__q3r_BG__login__title",
});
